import { Ghost } from 'lucide-react';

/**
 * Header pill that puts the chat into temporary mode.
 *
 * Temporary is a pure client concern: the request goes out with a null
 * conversation id, and the backend's persistence step skips any turn without
 * one. Nothing is written, so nothing has to be cleaned up later.
 *
 * Off: a quiet hollow ghost. On: the pill tints sage, the ghost drifts, and
 * the word "Temporary" slides out beside it.
 */
export default function TemporaryChatToggle({ value, onChange }) {
  return (
    <>
      <style>{`
        @keyframes mwGhostDrift {
          0%, 100% { transform: translateY(0); }
          50% { transform: translateY(-2px); }
        }
        .mw-ghost-drift { animation: mwGhostDrift 2.6s ease-in-out infinite; }
        @media (prefers-reduced-motion: reduce) {
          .mw-ghost-drift { animation: none; }
        }
      `}</style>
      <button
        type="button"
        role="switch"
        aria-checked={value}
        aria-label="Temporary chat"
        title={value ? 'Temporary chat on — not saved' : 'Temporary chat'}
        onClick={() => onChange(!value)}
        className={[
          'flex items-center gap-1.5 h-9 rounded-full border transition-all duration-300 ease-out',
          'focus:outline-none focus-visible:ring-2 focus-visible:ring-[#7C9A82]/40',
          value
            ? 'pl-2.5 pr-3 border-[#7C9A82]/45 bg-[#7C9A82]/12 text-[#7C9A82]'
            : 'px-2.5 border-transparent text-stone-500 hover:text-stone-800 hover:bg-stone-100',
        ].join(' ')}
      >
        <Ghost
          size={17}
          className={value ? 'mw-ghost-drift' : undefined}
          fill={value ? 'currentColor' : 'none'}
          aria-hidden="true"
        />
        <span
          className={[
            'font-sans text-xs font-semibold tracking-wide overflow-hidden whitespace-nowrap',
            'transition-all duration-300 ease-out',
            value ? 'max-w-[6rem] opacity-100' : 'max-w-0 opacity-0',
          ].join(' ')}
        >
          Temporary
        </span>
      </button>
    </>
  );
}
